import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setLoginError('');
    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.success) {
        sessionStorage.setItem('adminToken', response.data.token);
        onLoginSuccess();
        setPassword('');
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setLoginError('Invalid password. Please try again.');
      } else {
        setLoginError('Login failed. Please try again.');
      }
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="dark-page admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <Lock size={48} className="admin-lock-icon" />
            <h1 className="display-large admin-login-title">Admin Access</h1>
            <p className="body-medium admin-login-subtitle">
              Enter your password to access the dashboard
            </p>
          </div>

          <form onSubmit={handleLogin} className="admin-login-form">
            <div className="admin-password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="admin-password-input"
                data-testid="admin-password-input"
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="admin-password-toggle"
                data-testid="toggle-password-visibility"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {loginError && (
              <div className="admin-login-error" data-testid="login-error">
                {loginError}
              </div>
            )}

            <button
              type="submit"
              className="btn-primary admin-login-btn"
              disabled={loginLoading || !password}
              data-testid="admin-login-btn"
            >
              {loginLoading ? 'Verifying...' : 'Access Dashboard'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
